// NATIVE 
import React from 'react';


// INSTALLED 


// CUSTOM 
import { useSelector } from 'react-redux';
import { Grid, TextField } from '@mui/material';





/**
 * DetalleArea component displays the details of an area.
 * 
 * @param {any} props - The properties passed to the component.
 * 
 * @returns {JSX.Element} A React component that renders the details of an area.
 * 
 * @remarks
 * This component uses the `useSelector` hook to access the `area` from the Redux store.
 * It also uses the `useEffect` hook to update the local state `dataTerminal` whenever the `area` changes.
 * 
 * @example
 * ```tsx
 * <DetalleArea />
 * ```
 */
export const DetalleTerminalEmpleados = (props:any) => {


    // USE SELECTOR 
    const { terminal }:any  = useSelector( (state:any) => state.terminals );
    const  [dataTerminal, setDataTerminal] = React.useState<any>(null);


    // USE EFFECT 
    React.useEffect(() => {
        setDataTerminal(terminal);
    }, [terminal]);




  return (
    <div>
        
        {
            dataTerminal &&  
              <>
                 <Grid>
                    <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
                        <TextField
                            fullWidth
                            name={dataTerminal.name}
                            label={'Nombre'}
                            defaultValue={dataTerminal.name}
                            InputProps={{
                            readOnly: true,
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid>
                    <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
                        <TextField
                            fullWidth
                            name={dataTerminal.code}
                            label={'Codigo'}
                            defaultValue={dataTerminal.code}
                            InputProps={{
                            readOnly: true,
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid>
                    <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
                        <TextField
                            fullWidth
                            name={dataTerminal.typeTerminal}
                            label={'Tipo terminal'}
                            defaultValue={dataTerminal.typeTerminal}
                            InputProps={{
                            readOnly: true,
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid>
                    <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
                        <TextField
                            fullWidth
                            multiline
                            rows={5}
                            name={dataTerminal.description}
                            label={'Descripcion'}
                            defaultValue={dataTerminal.description}
                            InputProps={{
                            readOnly: true,
                            }}
                        />
                    </Grid>
                </Grid>
              </>
        }
    </div>
  )
}
